import { Link } from "react-router-dom";
import { LOGO_URL, waLink, WHATSAPP_DISPLAY } from "@/lib/brand";
import { MessageCircle, MapPin } from "lucide-react";

const WORDS = ["Valorizzare", "Presentare", "Posizionare", "Vendere"];

export function Marquee() {
  const items = [...WORDS, ...WORDS, ...WORDS, ...WORDS];
  return (
    <div className="py-10 bg-brand overflow-hidden border-y border-brand-hover">
      <div className="flex w-max animate-marquee">
        {items.map((w, i) => (
          <span key={`${w}-${i}`} className="flex items-center whitespace-nowrap">
            <span className="font-display italic text-white text-4xl sm:text-5xl px-8">{w}</span>
            <span className="text-white/40 text-3xl">—</span>
          </span>
        ))}
      </div>
    </div>
  );
}

export default function Footer({ onValuation }) {
  return (
    <footer className="bg-anthracite text-white py-16">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div className="max-w-sm">
            <img src={LOGO_URL} alt="Casamore" className="h-14 w-auto brightness-0 invert mb-5" />
            <p className="text-white/60 leading-relaxed">
              Servizi immobiliari a Corato. Valorizziamo, presentiamo e posizioniamo il tuo immobile
              per venderlo nelle migliori condizioni.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-xs uppercase tracking-[0.2em] font-semibold text-white/40 mb-1">Naviga</span>
            <Link to="/" className="text-white/80 hover:text-white transition-colors" data-testid="footer-link-home">Vendere</Link>
            <Link to="/immobili" className="text-white/80 hover:text-white transition-colors" data-testid="footer-link-immobili">Immobili</Link>
            <Link to="/casa-crush" className="text-white/80 hover:text-white transition-colors" data-testid="footer-link-casacrush">Casa Crush</Link>
            <Link to="/mutuo" className="text-white/80 hover:text-white transition-colors" data-testid="footer-link-mutuo">Mutuo Check</Link>
            <Link to="/cambio-casa" className="text-white/80 hover:text-white transition-colors" data-testid="footer-link-cambiocasa">Cambio Casa</Link>
            <Link to="/vacanze" className="text-white/80 hover:text-white transition-colors" data-testid="footer-link-vacanze">Vieni in Vacanza da Noi</Link>
          </div>
          <div className="flex flex-col gap-4">
            <a
              href={waLink("Salve Pierluigi, vorrei alcune informazioni.")}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors"
              data-testid="footer-whatsapp"
            >
              <MessageCircle className="h-4 w-4 text-brand" /> {WHATSAPP_DISPLAY}
            </a>
            <span className="inline-flex items-center gap-2 text-white/60">
              <MapPin className="h-4 w-4 text-brand" /> Corato (BA)
            </span>
            <button
              onClick={onValuation}
              className="mt-2 self-start rounded-full bg-brand text-white font-semibold px-6 py-3 transition-transform hover:scale-[1.04]"
              data-testid="footer-valuation-cta"
            >
              Scopri quanto può valere
            </button>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/10 text-sm text-white/40">
          © {new Date().getFullYear()} Casamore Servizi Immobiliari — Pierluigi Amorese
        </div>
      </div>
    </footer>
  );
}
